import type { NodeSpec, Node as ProsemirrorNode, DOMOutputSpec } from 'prosemirror-model';

import type { RtSchemaType } from '../../editor/types';
import { HtmlClassExtension } from '../../extensions/html-class';
import { NodeName } from '../../schema/nodes';

export class BlockquoteNode implements NodeSpec {
  public static readonly nodeName = NodeName.Blockquote;
  public static is(node: ProsemirrorNode) {
    return node.type.name === BlockquoteNode.nodeName;
  }
  private readonly htmlClassExtension?: HtmlClassExtension;
  public attrs = {
    ...(this.config?.withHtmlClass && HtmlClassExtension.attrs),
  };
  public content = 'block+';
  public group = 'block';
  public parseDOM = [
    {
      tag: 'blockquote',
      getAttrs: (node: HTMLElement) => ({
        ...(this.htmlClassExtension && this.htmlClassExtension.parseDOMGetAttrs(node)),
      }),
    },
  ];

  constructor(
    private config?: {
      withHtmlClass?: boolean;
    },
  ) {
    if (config?.withHtmlClass) {
      this.htmlClassExtension = new HtmlClassExtension();
    }
  }
  public toDOM = (node: ProsemirrorNode): DOMOutputSpec => {
    let attributes = {};
    if (this.htmlClassExtension) {
      attributes = {
        class: this.htmlClassExtension.getClassSerialization(node),
      };
    }
    return ['blockquote', attributes, 0];
  };
}

export type BlockquoteSchema = RtSchemaType<typeof BlockquoteNode>;
